/*!--------------------------------------------------------
 * Copyright (C) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
/*---------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 *--------------------------------------------------------*/
define("vs/workbench/api/worker/extensionHostWorker.nls", {
	"vs/base/common/date": [
		"in {0}",
		"now",
		"{0} second ago",
		"{0} sec ago",
		"{0} seconds ago",
		"{0} secs ago",
		"{0} second",
		"{0} sec",
		"{0} seconds",
		"{0} secs",
		"{0} minute ago",
		"{0} min ago",
		"{0} minutes ago",
		"{0} mins ago",
		"{0} minute",
		"{0} min",
		"{0} minutes",
		"{0} mins",
		"{0} hour ago",
		"{0} hr ago",
		"{0} hours ago",
		"{0} hrs ago",
		"{0} hour",
		"{0} hr",
		"{0} hours",
		"{0} hrs",
		"{0} day ago",
		"{0} days ago",
		"{0} day",
		"{0} days",
		"{0} week ago",
		"{0} wk ago",
		"{0} weeks ago",
		"{0} wks ago",
		"{0} week",
		"{0} wk",
		"{0} weeks",
		"{0} wks",
		"{0} month ago",
		"{0} mo ago",
		"{0} months ago",
		"{0} mos ago",
		"{0} month",
		"{0} mo",
		"{0} months",
		"{0} mos",
		"{0} year ago",
		"{0} yr ago",
		"{0} years ago",
		"{0} yrs ago",
		"{0} year",
		"{0} yr",
		"{0} years",
		"{0} yrs"
	],
	"vs/base/common/errorMessage": [
		"{0}: {1}",
		"A system error occurred ({0})",
		"An unknown error occurred. Please consult the log for more details.",
		"An unknown error occurred. Please consult the log for more details.",
		"{0} ({1} errors in total)",
		"An unknown error occurred. Please consult the log for more details."
	],
	"vs/editor/common/config/editorOptions": [
		"The editor will use platform APIs to detect when a Screen Reader is attached.",
		"The editor will be permanently optimized for usage with a Screen Reader. Word wrapping will be disabled.",
		"The editor will never be optimized for usage with a Screen Reader.",
		"Controls whether the editor should run in a mode where it is optimized for screen readers. Setting to on will disable word wrapping.",
		"Controls whether a space character is inserted when commenting.",
		"Controls if empty lines should be ignored with toggle, add or remove actions for line comments.",
		"Controls whether copying without a selection copies the current line.",
		"Controls whether the cursor should jump to find matches while typing.",
		"Never seed search string from the editor selection.",
		"Always seed search string from the editor selection, including word at cursor position.",
		"Only seed search string from the editor selection.",
		"Controls whether the search string in the Find Widget is seeded from the editor selection.",
		"Never turn on Find in Selection automatically (default).",
		"Always turn on Find in Selection automatically.",
		"Turn on Find in Selection automatically when multiple lines of content are selected.",
		"Controls the condition for turning on Find in Selection automatically.",
		"Controls whether the Find Widget should read or modify the shared find clipboard on macOS.",
		"Controls whether the Find Widget should add extra lines on top of the editor. When true, you can scroll beyond the first line when the Find Widget is visible.",
		"Controls whether the search automatically restarts from the beginning (or the end) when no further matches can be found.",
		"Enables/Disables font ligatures ('calt' and 'liga' font features). Change this to a string for fine-grained control of the 'font-feature-settings' CSS property.",
		"Explicit 'font-feature-settings' CSS property. A boolean can be passed instead if one only needs to turn on/off ligatures.",
		"Configures font ligatures or font features. Can be either a boolean to enable/disable ligatures or a string for the value of the CSS 'font-feature-settings' property.",
		"Controls the font size in pixels.",
		"Only \"normal\" and \"bold\" keywords or numbers between 1 and 1000 are allowed.",
		"Controls the font weight. Accepts \"normal\" and \"bold\" keywords or numbers between 1 and 1000.",
		"Show peek view of the results (default)",
		"Go to the primary result and show a peek view",
		"Go to the primary result and enable peek-less navigation to others",
		"This setting is deprecated, please use separate settings like 'editor.editor.gotoLocation.multipleDefinitions' or 'editor.editor.gotoLocation.multipleImplementations' instead.",
		"Controls the behavior the 'Go to Definition'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to Type Definition'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to Declaration'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to Implementations'-command when multiple target locations exist.",
		"Controls the behavior the 'Go to References'-command when multiple target locations exist.",
		"Alternative command id that is being executed when the result of 'Go to Definition' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Type Definition' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Declaration' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Implementation' is the current location.",
		"Alternative command id that is being executed when the result of 'Go to Reference' is the current location.",
		"Controls whether the hover is shown.",
		"Controls the delay in milliseconds after which the hover is shown.",
		"Controls whether the hover should remain visible when mouse is moved over it.",
		"Prefer showing hovers above the line, if there's space.",
		"Enables the code action lightbulb in the editor.",
		"Shows the nested current scopes during the scroll at the top of the editor.",
		"Enables the inlay hints in the editor.",
		"Inlay hints are enabled",
		"Inlay hints are showing by default and hide when holding `Ctrl+Alt`",
		"Inlay hints are hidden by default and show when holding `Ctrl+Alt`",
		"Inlay hints are disabled",
		"Controls font size of inlay hints in the editor. As default the {0} is used when the configured value is less than {1} or greater than the editor font size.",
		"Controls font family of inlay hints in the editor. When set to empty, the {0} is used.",
		"Enables the padding around the inlay hints in the editor.",
		"Controls the line height. \n - Use 0 to automatically compute the line height from the font size.\n - Values between 0 and 8 will be used as a multiplier with the font size.\n - Values greater than or equal to 8 will be used as effective values.",
		"Controls whether the minimap is shown.",
		"Controls whether the minimap is hidden automatically.",
		"The minimap has the same size as the editor contents (and might scroll).",
		"The minimap will stretch or shrink as necessary to fill the height of the editor (no scrolling).",
		"The minimap will shrink as necessary to never be larger than the editor (no scrolling).",
		"Controls the size of the minimap.",
		"Controls the side where to render the minimap.",
		"Controls when the minimap slider is shown.",
		"Scale of content drawn in the minimap: 1, 2 or 3.",
		"Render the actual characters on a line as opposed to color blocks.",
		"Limit the width of the minimap to render at most a certain number of columns.",
		"Controls the amount of space between the top edge of the editor and the first line.",
		"Controls the amount of space between the bottom edge of the editor and the last line.",
		"Enables a pop-up that shows parameter documentation and type information as you type.",
		"Controls whether the parameter hints menu cycles or closes when reaching the end of the list.",
		"Quick suggestions show inside the suggest widget",
		"Quick suggestions show as ghost text",
		"Quick suggestions are disabled",
		"Enable quick suggestions inside strings.",
		"Enable quick suggestions inside comments.",
		"Enable quick suggestions outside of strings and comments.",
		"Controls whether suggestions should automatically show up while typing. This can be controlled for typing in comments, strings, and other code. Quick suggestion can be configured to show as ghost text or with the suggest widget. Also be aware of the '{0}'-setting which controls if suggestions are triggered by special characters.",
		"Line numbers are not rendered.",
		"Line numbers are rendered as absolute number.",
		"Line numbers are rendered as distance in lines to cursor position.",
		"Line numbers are rendered every 10 lines.",
		"Controls the display of line numbers.",
		"Number of monospace characters at which this editor ruler will render.",
		"Color of this editor ruler.",
		"Render vertical rulers after a certain number of monospace characters. Use multiple values for multiple rulers. No rulers are drawn if array is empty.",
		"The vertical scrollbar will be visible only when necessary.",
		"The vertical scrollbar will always be visible.",
		"The vertical scrollbar will always be hidden.",
		"Controls the visibility of the vertical scrollbar.",
		"The horizontal scrollbar will be visible only when necessary.",
		"The horizontal scrollbar will always be visible.",
		"The horizontal scrollbar will always be hidden.",
		"Controls the visibility of the horizontal scrollbar.",
		"The width of the vertical scrollbar.",
		"The height of the horizontal scrollbar.",
		"Controls whether clicks scroll by page or jump to click position.",
		"Controls whether all non-basic ASCII characters are highlighted. Only characters between U+0020 and U+007E, tab, line-feed and carriage-return are considered basic ASCII.",
		"Controls whether characters that just reserve space or have no width at all are highlighted.",
		"Controls whether characters are highlighted that can be confused with basic ASCII characters, except those that are common in the current user locale.",
		"Controls whether characters in comments should also be subject to unicode highlighting.",
		"Controls whether characters in strings should also be subject to unicode highlighting.",
		"Defines allowed characters that are not being highlighted.",
		"Unicode characters that are common in allowed locales are not being highlighted.",
		"Controls whether to automatically show inline suggestions in the editor.",
		"Controls whether bracket pair colorization is enabled or not. Use {0} to override the bracket highlight colors.",
		"Controls whether each bracket type has its own independent color pool.",
		"Enables bracket pair guides.",
		"Enables bracket pair guides only for the active bracket pair.",
		"Disables bracket pair guides.",
		"Controls whether bracket pair guides are enabled or not.",
		"Enables horizontal guides as addition to vertical bracket pair guides.",
		"Enables horizontal guides only for the active bracket pair.",
		"Disables horizontal bracket pair guides.",
		"Controls whether horizontal bracket pair guides are enabled or not.",
		"Controls whether the editor should highlight the active bracket pair.",
		"Controls whether the editor should render indent guides.",
		"Highlights the active indent guide.",
		"Highlights the active indent guide even if bracket guides are highlighted.",
		"Do not highlight the active indent guide.",
		"Controls whether the editor should highlight the active indent guide.",
		"Insert suggestion without overwriting text right of the cursor.",
		"Insert suggestion and overwrite text right of the cursor.",
		"Controls whether words are overwritten when accepting completions. Note that this depends on extensions opting into this feature.",
		"Controls whether filtering and sorting suggestions accounts for small typos.",
		"Controls whether sorting favors words that appear close to the cursor.",
		"Controls whether remembered suggestion selections are shared between multiple workspaces and windows (needs `#editor.suggestSelection#`).",
		"Controls whether an active snippet prevents quick suggestions.",
		"Controls whether to show or hide icons in suggestions.",
		"Controls the visibility of the status bar at the bottom of the suggest widget.",
		"Controls whether to preview the suggestion outcome in the editor.",
		"Controls whether suggest details show inline with the label or only in the details widget",
		"This setting is deprecated. The suggest widget can now be resized.",
		"This setting is deprecated, please use separate settings like 'editor.suggest.showKeywords' or 'editor.suggest.showSnippets' instead.",
		"When enabled IntelliSense shows `method`-suggestions.",
		"When enabled IntelliSense shows `function`-suggestions.",
		"When enabled IntelliSense shows `constructor`-suggestions.",
		"When enabled IntelliSense shows `deprecated`-suggestions.",
		"When enabled IntelliSense shows `field`-suggestions.",
		"When enabled IntelliSense shows `variable`-suggestions.",
		"When enabled IntelliSense shows `class`-suggestions.",
		"When enabled IntelliSense shows `struct`-suggestions.",
		"When enabled IntelliSense shows `interface`-suggestions.",
		"When enabled IntelliSense shows `module`-suggestions.",
		"When enabled IntelliSense shows `property`-suggestions.",
		"When enabled IntelliSense shows `event`-suggestions.",
		"When enabled IntelliSense shows `operator`-suggestions.",
		"When enabled IntelliSense shows `unit`-suggestions.",
		"When enabled IntelliSense shows `value`-suggestions.",
		"When enabled IntelliSense shows `constant`-suggestions.",
		"When enabled IntelliSense shows `enum`-suggestions.",
		"When enabled IntelliSense shows `enumMember`-suggestions.",
		"When enabled IntelliSense shows `keyword`-suggestions.",
		"When enabled IntelliSense shows `text`-suggestions.",
		"When enabled IntelliSense shows `color`-suggestions.",
		"When enabled IntelliSense shows `file`-suggestions.",
		"When enabled IntelliSense shows `reference`-suggestions.",
		"When enabled IntelliSense shows `customcolor`-suggestions.",
		"When enabled IntelliSense shows `folder`-suggestions.",
		"When enabled IntelliSense shows `typeParameter`-suggestions.",
		"When enabled IntelliSense shows `snippet`-suggestions.",
		"When enabled IntelliSense shows `user`-suggestions.",
		"When enabled IntelliSense shows `issues`-suggestions.",
		"Whether leading and trailing whitespace should always be selected.",
		"Controls whether you can drag and drop a file into a text editor by holding down `shift` (instead of opening the file in an editor).",
		"Controls whether suggestions should be accepted on commit characters. For example, in JavaScript, the semi-colon (`; `) can be a commit character that accepts a suggestion and types that character.",
		"Only accept a suggestion with `Enter` when it makes a textual change.",
		"Controls whether suggestions should be accepted on `Enter`, in addition to `Tab`. Helps to avoid ambiguity between inserting new lines or accepting suggestions.",
		"Controls the number of lines in the editor that can be read out by a screen reader at once. When we detect a screen reader we automatically set the default to be 500. Warning: this has a performance implication for numbers larger than the default.",
		"Editor content",
		"Use language configurations to determine when to autoclose brackets.",
		"Autoclose brackets only when the cursor is to the left of whitespace.",
		"Controls whether the editor should automatically close brackets after the user adds an opening bracket.",
		"Remove adjacent closing quotes or brackets only if they were automatically inserted.",
		"Controls whether the editor should remove adjacent closing quotes or brackets when deleting.",
		"Type over closing quotes or brackets only if they were automatically inserted.",
		"Controls whether the editor should type over closing quotes or brackets.",
		"Use language configurations to determine when to autoclose quotes.",
		"Autoclose quotes only when the cursor is to the left of whitespace.",
		"Controls whether the editor should automatically close quotes after the user adds an opening quote.",
		"The editor will not insert indentation automatically.",
		"The editor will keep the current line's indentation.",
		"The editor will keep the current line's indentation and honor language defined brackets.",
		"The editor will keep the current line's indentation, honor language defined brackets and invoke special onEnterRules defined by languages.",
		"The editor will keep the current line's indentation, honor language defined brackets, invoke special onEnterRules defined by languages, and honor indentationRules defined by languages.",
		"Controls whether the editor should automatically adjust the indentation when users type, paste, move or indent lines.",
		"Use language configurations to determine when to automatically surround selections.",
		"Surround with quotes but not brackets.",
		"Surround with brackets but not quotes.",
		"Controls whether the editor should automatically surround selections when typing quotes or brackets.",
		"Emulate selection behavior of tab characters when using spaces for indentation. Selection will stick to tab stops.",
		"Controls whether the editor shows CodeLens.",
		"Controls the font family for CodeLens.",
		"Controls the font size in pixels for CodeLens. When set to `0`, 90% of `#editor.fontSize#` is used.",
		"Controls whether the editor should render the inline color decorators and color picker.",
		"Enable that the selection with the mouse and keys is doing column selection.",
		"Controls whether syntax highlighting should be copied into the clipboard.",
		"Control the cursor animation style.",
		"Controls whether the smooth caret animation should be enabled.",
		"Controls the cursor style.",
		"Controls the minimal number of visible leading and trailing lines surrounding the cursor. Known as 'scrollOff' or 'scrollOffset' in some other editors.",
		"`cursorSurroundingLines` is enforced only when triggered via the keyboard or API.",
		"`cursorSurroundingLines` is enforced always.",
		"Controls when `cursorSurroundingLines` should be enforced.",
		"Controls the width of the cursor when `#editor.cursorStyle#` is set to `line`.",
		"Controls whether the editor should allow moving selections via drag and drop.",
		"Scrolling speed multiplier when pressing `Alt`.",
		"Controls whether the editor has code folding enabled.",
		"Use a language-specific folding strategy if available, else the indentation-based one.",
		"Use the indentation-based folding strategy.",
		"Controls the strategy for computing folding ranges.",
		"Controls whether the editor should highlight folded ranges.",
		"Controls whether the editor automatically collapses import ranges.",
		"The maximum number of foldable regions. Increasing this value may result in the editor becoming less responsive when the current source has a large number of foldable regions.",
		"Controls whether clicking on the empty content after a folded line will unfold the line.",
		"Controls the font family.",
		"Controls whether the editor should automatically format the pasted content. A formatter must be available and the formatter should be able to format a range in a document.",
		"Controls whether the editor should automatically format the line after typing.",
		"Controls whether the editor should render the vertical glyph margin. Glyph margin is mostly used for debugging.",
		"Controls whether the cursor should be hidden in the overview ruler.",
		"Controls the letter spacing in pixels.",
		"Controls whether the editor has linked editing enabled. Depending on the language, related symbols, e.g. HTML tags, are updated while editing.",
		"Controls whether the editor should detect links and make them clickable.",
		"Highlight matching brackets.",
		"A multiplier to be used on the `deltaX` and `deltaY` of mouse wheel scroll events.",
		"Zoom the font of the editor when using mouse wheel and holding `Ctrl`.",
		"Merge multiple cursors when they are overlapping.",
		"Maps to `Control` on Windows and Linux and to `Command` on macOS.",
		"Maps to `Alt` on Windows and Linux and to `Option` on macOS.",
		"The modifier to be used to add multiple cursors with the mouse. The Go to Definition and Open Link mouse gestures will adapt such that they do not conflict with the [multicursor modifier](https://code.visualstudio.com/docs/editor/codebasics#_multicursor-modifier).",
		"Each cursor pastes a single line of the text.",
		"Each cursor pastes the full text.",
		"Controls pasting when the line count of the pasted text matches the cursor count.",
		"Controls whether the editor should highlight semantic symbol occurrences.",
		"Controls whether a border should be drawn around the overview ruler.",
		"Focus the tree when opening peek",
		"Focus the editor when opening peek",
		"Controls whether to focus the inline editor or the tree in the peek widget.",
		"Controls whether the Go to Definition mouse gesture always opens the peek widget.",
		"Controls the delay in milliseconds after which quick suggestions will show up.",
		"Controls whether the editor auto renames on type.",
		"Deprecated, use `editor.linkedEditing` instead.",
		"Controls whether the editor should render control characters.",
		"Render last line number when the file ends with a newline.",
		"Highlights both the gutter and the current line.",
		"Controls how the editor should render the current line highlight.",
		"Controls if the editor should render the current line highlight only when the editor is focused.",
		"Render whitespace characters except for single spaces between words.",
		"Render whitespace characters only on selected text.",
		"Render only trailing whitespace characters.",
		"Controls how the editor should render whitespace characters.",
		"Controls whether selections should have rounded corners.",
		"Controls the number of extra characters beyond which the editor will scroll horizontally.",
		"Controls whether the editor will scroll beyond the last line.",
		"Scroll only along the predominant axis when scrolling both vertically and horizontally at the same time. Prevents horizontal drift when scrolling vertically on a trackpad.",
		"Controls whether the Linux primary clipboard should be supported.",
		"Controls whether the editor should highlight matches similar to the selection.",
		"Always show the folding controls.",
		"Never show the folding controls and reduce the gutter size.",
		"Only show the folding controls when the mouse is over the gutter.",
		"Controls when the folding controls on the gutter are shown.",
		"Controls fading out of unused code.",
		"Controls strikethrough deprecated variables.",
		"Show snippet suggestions on top of other suggestions.",
		"Show snippet suggestions below other suggestions.",
		"Show snippets suggestions with other suggestions.",
		"Do not show snippet suggestions.",
		"Controls whether snippets are shown with other suggestions and how they are sorted.",
		"Controls whether the editor will scroll using an animation.",
		"Font size for the suggest widget. When set to {0}, the value of {1} is used.",
		"Line height for the suggest widget. When set to {0}, the value of {1} is used. The minimum value is 8.",
		"Controls whether suggestions should automatically show up when typing trigger characters.",
		"Always select the first suggestion.",
		"Select recent suggestions unless further typing selects one, e.g. `console.| -> console.log` because `log` has been completed recently.",
		"Select suggestions based on previous prefixes that have completed those suggestions, e.g. `co -> console` and `con -> const`.",
		"Controls how suggestions are pre-selected when showing the suggest list.",
		"Tab complete will insert the best matching suggestion when pressing tab.",
		"Disable tab completions.",
		"Tab complete snippets when their prefix match. Works best when 'quickSuggestions' aren't enabled.",
		"Enables tab completions.",
		"Unusual line terminators are automatically removed.",
		"Unusual line terminators are ignored.",
		"Unusual line terminators prompt to be removed.",
		"Remove unusual line terminators that might cause problems.",
		"Inserting and deleting whitespace follows tab stops.",
		"Characters that will be used as word separators when doing word related navigations or operations.",
		"Lines will never wrap.",
		"Lines will wrap at the viewport width.",
		"Lines will wrap at `#editor.wordWrapColumn#`.",
		"Lines will wrap at the minimum of viewport and `#editor.wordWrapColumn#`.",
		"Controls how lines should wrap.",
		"Controls the wrapping column of the editor when `#editor.wordWrap#` is `wordWrapColumn` or `bounded`.",
		"No indentation. Wrapped lines begin at column 1.",
		"Wrapped lines get the same indentation as the parent.",
		"Wrapped lines get +1 indentation toward the parent.",
		"Wrapped lines get +2 indentation toward the parent.",
		"Controls the indentation of wrapped lines.",
		"Assumes that all characters are of the same width. This is a fast algorithm that works correctly for monospace fonts and certain scripts (like Latin characters) where glyphs are of equal width.",
		"Delegates wrapping points computation to the browser. This is a slow algorithm, that might cause freezes for large files, but it works correctly in all cases.",
		"Controls the algorithm that computes wrapping points."
	],
	"vs/platform/configuration/common/configurationRegistry": [
		"Default Language Configuration Overrides",
		"Configure settings to be overridden for the {0} language.",
		"Configure editor settings to be overridden for a language.",
		"This setting does not support per-language configuration.",
		"Configure editor settings to be overridden for a language.",
		"This setting does not support per-language configuration.",
		"Cannot register an empty property",
		"Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.",
		"Cannot register '{0}'. This property is already registered.",
		"Cannot register '{0}'. The associated policy {1} is already registered with {2}."
	],
	"vs/platform/extensionManagement/common/extensionManagement": [
		"Extensions",
		"Preferences"
	],
	"vs/platform/extensions/common/extensionValidator": [
		"property publisher must be of type `string`.",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` is mandatory and must be of type `object`",
		"property `{0}` is mandatory and must be of type `string`",
		"property `{0}` can be omitted or must be of type `string[]`",
		"property `{0}` can be omitted or must be of type `string[]`",
		"properties `{0}` and `{1}` must both be specified or must both be omitted",
		"property `{0}` can be defined only if property `main` is also defined.",
		"property `{0}` can be omitted or must be of type `string`",
		"Expected `main` ({0}) to be included inside extension's folder ({1}). This might make the extension non-portable.",
		"properties `{0}` and `{1}` must both be specified or must both be omitted",
		"property `{0}` can be omitted or must be of type `string`",
		"Expected `browser` ({0}) to be included inside extension's folder ({1}). This might make the extension non-portable.",
		"properties `{0}` and `{1}` must both be specified or must both be omitted",
		"Extension version is not semver compatible.",
		"Could not parse `engines.vscode` value {0}. Please use, for example: ^1.22.0, ^1.22.x, etc.",
		"Version specified in `engines.vscode` ({0}) is not specific enough. For vscode versions before 1.0.0, please define at a minimum the major and minor desired version. E.g. ^0.10.0, 0.10.x, 0.11.0, etc.",
		"Version specified in `engines.vscode` ({0}) is not specific enough. For vscode versions after 1.0.0, please define at a minimum the major desired version. E.g. ^1.10.0, 1.10.x, 1.x.x, 2.x.x, etc.",
		"Extension is not compatible with Code {0}. Extension requires: {1}."
	],
	"vs/platform/files/common/files": [
		"Unknown Error",
		"{0}B",
		"{0}KB",
		"{0}MB",
		"{0}GB",
		"{0}TB"
	],
	"vs/platform/markers/common/markers": [
		"Error",
		"Warning",
		"Info"
	],
	"vs/platform/workspace/common/workspace": [
		"Code Workspace"
	],
	"vs/workbench/api/common/extHostDiagnostics": [
		"Not showing {0} further errors and warnings."
	],
	"vs/workbench/api/common/extHostExtensionService": [
		"Cannot load test runner.",
		"Path {0} does not point to a valid extension test runner."
	],
	"vs/workbench/api/common/extHostProgress": [
		"{0} (Extension)"
	],
	"vs/workbench/api/common/extHostStatusBar": [
		"{0} (Extension)",
		"Extension Status"
	],
	"vs/workbench/api/common/extHostTerminalService": [
		"Could not find the terminal with id {0} on the extension host"
	],
	"vs/workbench/api/common/extHostTreeViews": [
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"No tree view with id '{0}' registered.",
		"Element with id {0} is already registered"
	],
	"vs/workbench/api/common/extHostWorkspace": [
		"Extension '{0}' failed to update workspace folders: {1}"
	],
	"vs/workbench/common/editor": [
		"Text Editor",
		"Built-in"
	],
	"vs/workbench/contrib/debug/common/abstractDebugAdapter": [
		"Timeout after {0} ms for '{1}'"
	],
	"vs/workbench/contrib/debug/common/debug": [
		"Debug type of the active debug session. For example 'python'.",
		"Debug type of the selected launch configuration. For example 'python'.",
		"State that the focused debug session is in. One of the following: 'inactive', 'initializing', 'stopped' or 'running'.",
		"Debug UX state. When there are no debug configurations it is 'simple', otherwise 'default'. Used to decide when to show welcome views in the debug viewlet.",
		"True when debugging, false otherwise.",
		"True when focus is in the debug console, false otherwise.",
		"True when breakpoint editor zone widget is visible, false otherwise.",
		"True when focus is in the breakpoint editor zone widget, false otherwise.",
		"True when the BREAKPOINTS view is focused, false otherwise.",
		"True when the WATCH view is focused, false otherwsie.",
		"True when at least one watch expression exists, false otherwise.",
		"True when the VARIABLES views is focused, false otherwsie",
		"True when an expression input box is open in either the WATCH or the VARIABLES view, false otherwise.",
		"True when the input box has focus in the BREAKPOINTS view.",
		"Represents the item type of the focused element in the CALL STACK view. For example: 'session', 'thread', 'stackFrame'",
		"True when the session in the CALL STACK view is attach, false otherwise. Used internally for inline menus in the CALL STACK view.",
		"True when the focused item in the CALL STACK is stopped. Used internaly for inline menus in the CALL STACK view.",
		"True when the focused session in the CALL STACK view has exactly one thread. Used internally for inline menus in the CALL STACK view.",
		"Represents the item type of the focused element in the WATCH view. For example: 'expression', 'variable'",
		"Indicates whether the item in the view has an associated memory refrence.",
		"Represents the item type of the focused element in the BREAKPOINTS view. For example: 'breakpoint', 'exceptionBreakppint', 'functionBreakpoint', 'dataBreakpoint'",
		"Represents the access type of the focused data breakpoint in the BREAKPOINTS view. For example: 'read', 'readWrite', 'write'",
		"True when the focused breakpoint supports conditions.",
		"True when the focused sessions supports the LOADED SCRIPTS view",
		"Represents the item type of the focused element in the LOADED SCRIPTS view.",
		"True when the focused session is 'attach'.",
		"True when the focused session supports 'stepBack' requests.",
		"True when the focused session supports 'restartFrame' requests.",
		"True when the focused stack frame suppots 'restartFrame'.",
		"True when the focused session supports 'jumpToCursor' request.",
		"True when the focused session supports 'stepIntoTargets' request.",
		"True when at least one breakpoint exists.",
		"True when there is at least one debug extensions active.",
		"True when there is at least one debug extension installed and enabled.",
		"Represents the context the debug adapter sets on the focused variable in the VARIABLES view.",
		"True when the focused session supports 'setVariable' request.",
		"True when the focused session supports 'setExpression' request.",
		"True when the focused session supports to break when value changes.",
		"True when the focused breakpoint supports to break when value is accessed.",
		"True when the focused breakpoint supports to break when value is read.",
		"True when the focused session supports the terminate debuggee capability.",
		"True when the focused session supports the suspend debuggee capability.",
		"True when the focused variable has an 'evalauteName' field set.",
		"True when the focused variable is readonly.",
		"True when the exception widget is visible.",
		"True when there is more than 1 debug console.",
		"True when there is more than 1 active debug session.",
		"True when the focused sessions supports disassemble request.",
		"True when the Disassembly View is focused.",
		"True when the language in the current editor supports disassemble request.",
		"True when the focused stack frame has instruction pointer reference.",
		"Configured debug type '{0}' is installed but not supported in this environment.",
		"Controls when the internal debug console should open."
	],
	"vs/workbench/contrib/tasks/common/taskDefinitionRegistry": [
		"The actual task type. Please note that types starting with a '$' are reserved for internal usage.",
		"Additional properties of the task type",
		"Condition which must be true to enable this type of task. Consider using `shellExecutionSupported`, `processExecutionSupported`, and `customExecutionSupported` as appropriate for this task definition. See the [API documentation](https://code.visualstudio.com/api/extension-guides/task-provider#when-clause) for more information.",
		"The task type configuration is missing the required 'taskType' property",
		"Contributes task kinds"
	],
	"vs/workbench/contrib/tasks/common/tasks": [
		"Whether a task is currently running.",
		"Tasks",
		"Error: the task identifier '{0}' is missing the required property '{1}'. The task identifier will be ignored."
	],
	"vs/workbench/services/configurationResolver/common/variableResolver": [
		"Variable {0} can not be resolved. Please open an editor.",
		"Variable {0}: can not find workspace folder of '{1}'.",
		"Variable {0} can not be resolved. No such folder '{1}'.",
		"Variable {0} can not be resolved in a multi folder workspace. Scope this variable using ':' and a workspace folder name.",
		"Variable {0} can not be resolved. Please open a folder.",
		"Variable {0} can not be resolved because no environment variable name is given.",
		"Variable {0} can not be resolved because setting '{1}' not found.",
		"Variable {0} can not be resolved because '{1}' is a structured value.",
		"Variable {0} can not be resolved because no settings name is given.",
		"Variable {0} can not be resolved because the extension {1} is not installed.",
		"Variable {0} can not be resolved because no extension name is given.",
		"Variable {0} can not be resolved. UserHome path is not defined",
		"Variable {0} can not be resolved. Make sure to have a line selected in the active editor.",
		"Variable {0} can not be resolved. Make sure to have some text selected in the active editor.",
		"Variable {0} can not be resolved because the command has no value."
	],
	"vs/workbench/services/extensions/common/extensionsRegistry": [
		"UI extension kind. In a remote window, such extensions are enabled only when available on the local machine.",
		"Workspace extension kind. In a remote window, such extensions are enabled only when available on the remote.",
		"Engine compatibility.",
		"For VS Code extensions, specifies the VS Code version that the extension is compatible with. Cannot be *. For example: ^0.10.5 indicates compatibility with a minimum VS Code version of 0.10.5.",
		"The publisher of the VS Code extension.",
		"The display name for the extension used in the VS Code gallery.",
		"The categories used by the VS Code gallery to categorize the extension.",
		"Use 'Programming  Languages' instead",
		"Banner used in the VS Code marketplace.",
		"The banner color on the VS Code marketplace page header.",
		"The color theme for the font used in the banner.",
		"All contributions of the VS Code extension represented by this package.",
		"Sets the extension to be flagged as a Preview in the Marketplace.",
		"Use `enabledApiProposals` instead.",
		"Enable API proposals to try them out. Only valid **during development**. Extensions **cannot be published** with this property. For more details visit: https://code.visualstudio.com/api/advanced-topics/using-proposed-api",
		"Activation events for the VS Code extension.",
		"An activation event emmited when a webview is loaded of a certain viewType",
		"An activation event emitted whenever a file that resolves to the specified language gets opened.",
		"An activation event emitted whenever the specified command gets invoked.",
		"An activation event emitted whenever a user is about to start debugging or about to setup debug configurations.",
		"An activation event emitted whenever a \"launch.json\" needs to be created (and all provideDebugConfigurations methods need to be called).",
		"An activation event emitted whenever a list of all debug configurations needs to be created (and all provideDebugConfigurations methods for the \"dynamic\" scope need to be called).",
		"An activation event emitted whenever a debug session with the specific type is about to be launched (and a corresponding resolveDebugConfiguration method needs to be called).",
		"An activation event emitted whenever a debug session with the specific type is about to be launched and a debug protocol tracker might be needed.",
		"An activation event emitted whenever a folder is opened that contains at least a file matching the specified glob pattern.",
		"An activation event emitted after the start-up finished (after all `*` activated extensions have finished activating).",
		"An activation event emitted whenever tasks of a certain type need to be listed or resolved.",
		"An activation event emitted whenever a file or folder is accessed with the given scheme.",
		"An activation event emitted whenever a search is started in the folder with the given scheme.",
		"An activation event emitted whenever the specified view is expanded.",
		"An activation event emitted whenever the specified user identity.",
		"An activation event emitted whenever a system-wide Uri directed towards this extension is open.",
		"An activation event emitted whenever a external uri (such as an http or https link) is being opened.",
		"An activation event emitted whenever the specified custom editor becomes visible.",
		"An activation event emitted whenever the specified notebook document is opened.",
		"An activation event emitted whenever sessions are requested from the specified authentication provider.",
		"An activation event emitted whenever a notebook output renderer is used.",
		"An activation event emitted when a specific terminal profile is launched.",
		"An activation event emitted when a specified walkthrough is opened.",
		"An activation event emitted on VS Code startup. To ensure a great end user experience, please use this activation event in your extension only when no other activation events combination works in your use-case.",
		"Array of badges to display in the sidebar of the Marketplace's extension page.",
		"Badge image URL.",
		"Badge link.",
		"Badge description.",
		"Controls the Markdown rendering engine used in the Marketplace. Either github (default) or standard.",
		"Controls the Q&A link in the Marketplace. Set to marketplace to enable the default Marketplace Q & A site. Set to a string to provide the URL of a custom Q & A site. Set to false to disable Q & A altogether.",
		"Dependencies to other extensions. The identifier of an extension is always ${publisher}.${name}. For example: vscode.csharp.",
		"A set of extensions that can be installed together. The identifier of an extension is always ${publisher}.${name}. For example: vscode.csharp.",
		"Define the kind of an extension. `ui` extensions are installed and run on the local machine while `workspace` extensions run on the remote.",
		"Define an extension which can run only on the local machine when connected to remote window.",
		"Define an extension which can run only on the remote machine when connected remote window.",
		"Define an extension which can run on either side, with a preference towards running on the local machine.",
		"Define an extension which can run on either side, with a preference towards running on the remote machine.",
		"Define an extension which cannot run in a remote context, neither on the local, nor on the remote machine.",
		"Declare the set of supported capabilities by the extension.",
		"Declares whether the extension should be enabled in virtual workspaces. A virtual workspace is a workspace which is not backed by any on-disk resources. When false, this extension will be automatically disabled in virtual workspaces. Default is true.",
		"Declares the level of support for virtual workspaces by the extension.",
		"The extension will be enabled in virtual workspaces with some functionality disabled.",
		"The extension will be enabled in virtual workspaces with all functionality enabled.",
		"The extension will not be enabled in virtual workspaces.",
		"A description of how virtual workspaces affects the extensions behavior and why it is needed. This only applies when `supported` is not `true`.",
		"Declares how the extension should be handled in untrusted workspaces.",
		"Declares the level of support for untrusted workspaces by the extension.",
		"The extension will be enabled in untrusted workspaces with some functionality disabled.",
		"The extension will be enabled in untrusted workspaces with all functionality enabled.",
		"The extension will not be enabled in untrusted workspaces.",
		"A list of configuration keys contributed by the extension that should not use workspace values in untrusted workspaces.",
		"A description of how workspace trust affects the extensions behavior and why it is needed. This only applies when `supported` is not `true`.",
		"Specify the location from where users can sponsor your extension.",
		"URL from where users can sponsor your extension. It must be a valid URL with a HTTP or HTTPS protocol. Example value: https://github.com/sponsors/nvaccess",
		"Script executed before the package is published as a VS Code extension.",
		"Uninstall hook for VS Code extension. Script that gets executed when the extension is completely uninstalled from VS Code which is when VS Code is restarted (shutdown and start) after the extension is uninstalled. Only Node scripts are supported.",
		"The path to a 128x128 pixel icon.",
		"API proposals that the respective extensions can freely use."
	],
	"vs/workbench/services/search/common/queryBuilder": [
		"Workspace folder does not exist: {0}"
	]
});